import { Alert, Flex, Form, Input, Space } from 'antd'
import './SignIn.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-solid-svg-icons'
import { green, grey } from '@ant-design/colors'
import ThemableButton from '../Items/ThemableButton'
import { useSignInMutation } from './authenticationQueries'
import { updateInstances } from '../api'
import { useEffect } from 'react'

type Props = {
  onSignIn: () => void
}

const TOKEN_NAME = 'synkedup_token'

const SignIn = ({ onSignIn }: Props) => {
  const signInMutation = useSignInMutation()

  useEffect(() => {
    if (signInMutation.isSuccess) {
      const token = signInMutation.data
      localStorage.setItem(TOKEN_NAME, JSON.stringify(token))
      updateInstances()
      onSignIn()
    }
  }, [signInMutation.isSuccess, signInMutation.data])

  const initialValues = { username: '', password: '' }

  const handleSignIn = (values: any) => {
    signInMutation.mutate({ username: values.username, password: values.password })
  }

  const onForgotPassword = () => {
    window.location.href = '#!/account/forgot-password'
  }

  return <div className="sign-in-container">
    <Space direction="vertical" size="middle" style={{ maxWidth: 400, padding: 8 }}>
      <img src="/images/synkedup-dark.png" alt="SynkedUP" style={{ maxWidth: '100%' }} />
      <Form layout="vertical" initialValues={initialValues} onFinish={handleSignIn} size="large">
        <Form.Item name="username" rules={[{ required: true, message: 'Email is required' }]}>
          <Input type="email" placeholder="Email" />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: 'Password is required' }]}>
          <Input.Password placeholder="Password" />
        </Form.Item>

        <Form.Item hidden={!signInMutation.isError}>
          <Alert message={(signInMutation.error as Error)?.message} type="error" showIcon />
        </Form.Item>

        <Flex justify="space-between" align="middle" wrap="wrap">
          <ThemableButton
            type="link"
            colorLink={grey[1]}
            onClick={onForgotPassword}
            href="#!/account/forgot-password"
          >
            Forgot Password?
          </ThemableButton>
          <ThemableButton
            type="primary"
            size="large"
            colorPrimary={green.primary!}
            icon={<FontAwesomeIcon icon={faLock} />}
            htmlType="submit"
            loading={signInMutation.isLoading}
          >
            Sign In
          </ThemableButton>
        </Flex>
      </Form>
    </Space>
  </div>
}

export default SignIn
